import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Animation } from '../../../../animations/types/animation.types';
import { ChildrenPropType } from '../../../types/component';
import { PREVIOUS_DIRECTION_ICON, NEXT_DIRECTION_ICON } from '../../Pagination/components/PaginationArrow/PaginatedArrow.constants';
import { getElementKey } from '../services';
import { ARROW_POSITION, DEFAULT_AUTO_SCROLL_INTERVAL, INDICATORS_POSITION } from '../services/constants';
export var DEFAULT_MOBILE_PROPS = {
  size: null,
  displayAll: false,
  displayAllColumns: 2,
  arrowsPosition: ARROW_POSITION.center
};
export var BaseCarouselPropTypes = {
  items: ChildrenPropType.isRequired,
  size: PropTypes.number,
  stepSize: PropTypes.number,
  grouping: PropTypes.number,
  autoScroll: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    interval: PropTypes.number
  })]),
  responsive: PropTypes.bool,
  continuous: PropTypes.bool,
  pageIndicatorIcon: PropTypes.string,
  displayIndicators: PropTypes.bool,
  displayPlayPauseButton: PropTypes.bool,
  displayLeftRightArrows: PropTypes.bool,
  indicatorsPosition: PropTypes.oneOf([INDICATORS_POSITION.top, INDICATORS_POSITION.bottom]),
  className: PropTypes.string,
  mobile: PropTypes.shape({
    displayAll: PropTypes.bool,
    displayAllColumns: PropTypes.number,
    size: PropTypes.number,
    arrowsPosition: PropTypes.oneOf([ARROW_POSITION.center, ARROW_POSITION.top, ARROW_POSITION.bottom])
  }),
  renderItemContainer: PropTypes.func,
  invertedDirection: PropTypes.bool,
  animation: Animation,
  leftArrowIcon: PropTypes.string,
  rightArrowIcon: PropTypes.string,
  slide: PropTypes.bool
};
export var BaseCarouselDefaultProps = {
  size: 3,
  stepSize: null,
  grouping: 1,
  autoScroll: {
    interval: DEFAULT_AUTO_SCROLL_INTERVAL
  },
  responsive: true,
  continuous: true,
  pageIndicatorIcon: 'circle outline',
  displayLeftRightArrows: true,
  displayIndicators: true,
  displayPlayPauseButton: true,
  indicatorsPosition: INDICATORS_POSITION.bottom,
  className: '',
  mobile: DEFAULT_MOBILE_PROPS,
  renderItemContainer: function renderItemContainer(item) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
    return /*#__PURE__*/React.createElement(Grid.Column, {
      key: getElementKey(item),
      className: "pagination-element ".concat(className),
      style: style
    }, item);
  },
  invertedDirection: false,
  animation: {},
  leftArrowIcon: PREVIOUS_DIRECTION_ICON,
  rightArrowIcon: NEXT_DIRECTION_ICON,
  slide: false
};